const API_URL = (import.meta.env["VITE_API_URL"] as string | undefined) ?? "https://api.structurify.dscvry.ai";

export interface AuditEntry {
  id: string;
  documentId: string | null;
  action: string;
  detail: string;
  ts: string;
  hash: string;
}

export async function listAuditEntries(session: string, limit = 100, offset = 0): Promise<AuditEntry[]> {
  const res = await fetch(`${API_URL}/api/audit?limit=${limit}&offset=${offset}`, {
    headers: { "Authorization": `Bearer ${session}` },
  });
  if (!res.ok) return [];
  const data = await res.json() as { entries: AuditEntry[] };
  return data.entries;
}
